import { Outlet, ScrollRestoration } from "react-router";
import { Footer } from "./components/footer";
import { Header } from "./components/header";
import { ScrollToTop } from "./components/scroll-to-top";
import { useReferralCapture } from "./hooks/use-referral-capture";

export default function Root() {
  useReferralCapture();

  return (
    <div className="relative min-h-dvh">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
      <ScrollRestoration />
    </div>
  );
}
